export enum Role {
  User = 0,
  Viewer = 1,
  Author = 2,
  EmployerAdmin = 3,
  TripleAdmin = 4,
  TripleaReadonlyAdmin = 5
}
